export default "__VITE_ASSET__d05afc28__"